import React from "react"

function Present({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 14.3C8 13.6 8.6 13 9.3 13H26.7C27.4 13 28 13.6 28 14.3V17H8V14.3Z"
        stroke="#003E4C"
        strokeWidth="0.75"
      />
      <path
        d="M9.3 17H26.7V26.1C26.7 26.8 26.1 27.4 25.5 27.4H10.5C9.8 27.4 9.3 26.8 9.3 26.1V17Z"
        stroke="#003E4C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M18 13V27.4" stroke="#003E4C" strokeWidth="0.75" />
      <path
        d="M18 13C16.9 11.7 14.4 9.9 12.9 9.9C12.1 9.9 11.7 10.2 11.7 10.9C11.7 12.3 13.4 13 14.8 13"
        stroke="#003E4C"
        strokeWidth="0.75"
      />
      <path
        d="M18 13C19.1 11.7 21.6 9.9 23.2 9.9C23.9 9.9 24.3 10.2 24.3 10.9C24.3 12.3 22.7 13 21.3 13"
        stroke="#003E4C"
        strokeWidth="0.75"
      />
    </svg>
  )
}
export default Present
